// Module
var code = "<div class=\"code-editor\">\n  <textarea class=\"form-control\" id=\"code-editor\" ng-model=\"value\" name=\"{{name}}\"></textarea>\n</div>\n";
// Exports
module.exports = code;